// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Test_Spec from "../Test.Spec/index.js";
import * as Test_Spec_Assertions from "../Test.Spec.Assertions/index.js";
var describe = /* #__PURE__ */ Test_Spec.describe(Data_Identity.monadIdentity);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff);
var shouldEqual = /* #__PURE__ */ Test_Spec_Assertions.shouldEqual(Effect_Aff.monadThrowAff)(Data_Show.showBoolean)(Data_Eq.eqBoolean);
var lessThanOrEq = /* #__PURE__ */ Data_Ord.lessThanOrEq(Fusion_Data_Speed.ordSpeed);
var isGigaTv = /* #__PURE__ */ Data_HeytingAlgebra.conj(/* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean))(/* #__PURE__ */ Data_String_CodeUnits.contains("VODAFONE_STB/7.2"))(/* #__PURE__ */ Data_String_CodeUnits.contains("Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE"));
var spec = /* #__PURE__ */ describe("Fusion.Regex")(/* #__PURE__ */ describe("isGigaTv")(/* #__PURE__ */ Test_Spec.it(Data_Identity.monadIdentity)(Test_Spec.exampleMUnit)("matches all user agents of GigaTV devices that has been recorded in the database")(/* #__PURE__ */ discard(/* #__PURE__ */ shouldEqual(/* #__PURE__ */ isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A112.99bb.nga BCM7271/7.2.A112.99bb.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wired)"))(true))(function () {
    return discard(shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A112.99bb.nga BCM7271/7.2.A112.99bb.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wireless)"))(true))(function () {
        return discard(shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A105.99daa.nga BCM7271/7.2.A105.99daa.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wired)"))(true))(function () {
            return discard(shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A105.99da.nga BCM7271/7.2.A105.99da.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wired)"))(true))(function () {
                return discard(shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A105.99daa.nga BCM7271/7.2.A105.99daa.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wireless)"))(true))(function () {
                    return discard(shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A115.99aa.nga BCM7271/7.2.A115.99aa.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wireless)"))(true))(function () {
                        return shouldEqual(isGigaTv("Mozilla/5.0, AppleWebKit/537.36, Chrome/92.0.4515.159, Safari/537.36, OPR/46.0.2207.0, OMI/4.22.1, VODAFONE_STB/7.2.A115.99aa.nga BCM7271/7.2.A115.99aa.nga/DCIW387/HIGH (Sagemcom_Broadband_SAS, DCIW387_UHD_VF_DE, Wired)"))(true);
                    });
                });
            });
        });
    });
}))));
var getUploadStreamConfig = function (prepareResult) {
    var $11 = {
        userAgent: prepareResult.init.client.userAgent,
        contractInfo: prepareResult.info.contractInfo
    };
    if ($11.userAgent instanceof Data_Maybe.Just && isGigaTv($11.userAgent.value0)) {
        return {
            uploadNumStreams: 1,
            uploadByteCount: Fusion_Data_Bytes.fromInt(5000000)
        };
    };
    if ($11.contractInfo.maxUploadBookedSpeed instanceof Data_Maybe.Just && lessThanOrEq($11.contractInfo.maxUploadBookedSpeed.value0)(Fusion_Data_Speed.fromBps(2.0e8))) {
        return {
            uploadNumStreams: 2,
            uploadByteCount: Fusion_Data_Bytes.fromInt(50000000)
        };
    };
    if ($11.contractInfo.maxUploadBookedSpeed instanceof Data_Maybe.Just) {
        return {
            uploadNumStreams: 2,
            uploadByteCount: Fusion_Data_Bytes.fromInt(100000000)
        };
    };
    return {
        uploadNumStreams: 2,
        uploadByteCount: Fusion_Data_Bytes.fromInt(50000000)
    };
};
export {
    getUploadStreamConfig,
    spec
};
